import { atom, WritableAtom } from 'jotai';
import { OperatorFunction, Subject } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { type Executor, createExecutor, connectPromise } from './executor';

export const atomWithPipes = <T, Parameter extends unknown[], K = void>(
  value: T,
  setter: WritableAtom<T, Parameter, K | Promise<K>>['write'],
  operators: OperatorFunction<Executor<Awaited<K>>, any>[]
) => {
  const $s = new Subject<Executor<Awaited<K>>>();
  $s.pipe(...(operators as [])).subscribe({
    error: () => {},
  });
  const newAtom = atom(value, async (get, set, ...data: Parameter) => {
    const fn: Executor<Awaited<K>> = createExecutor(() =>
      Promise.resolve(setter(get, set, ...data))
    );
    $s.next(fn);
    return fn.control.promise;
  });

  return newAtom;
};

export function shareMap<R>(
  project: (T: Executor<R>) => Promise<R>
): OperatorFunction<Executor<R>, R> {
  let shared: Promise<R> | null = null;
  return mergeMap(async (value: Executor<R>) => {
    if (!shared) {
      shared = project(value);
    } else {
      connectPromise(shared, value.control);
    }
    try {
      return await shared!;
    } catch {
      // 에러를 삼켜서 RxJS stream이 살아있게 유지
      // caller는 project(value) 내부의 connectPromise에 의해 이미 에러를 받음
      return undefined as R;
    } finally {
      shared = null;
    }
  });
}
